import { useSelector } from "react-redux";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { useState } from "react";
const LeaveActions = ({
  item,
  setItemId,
  setShowAdd,
  setDeleteId,
  setShowDelete,
  handleApproveRejectLeave,
}) => {
  const { user } = useSelector((state) => state.authReducer);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectionReason, setRejectionReason] = useState("");
  const [loading, setLoading] = useState(false);
  const actionOptions = [
    { value: "edit", label: "Edit" },
    { value: "delete", label: "Delete" },
  ];

  const handleChange = (selectedOption) => {
    if (selectedOption === "edit") {
      setItemId(item.id);
      setShowAdd(true);
    } else if (selectedOption === "delete") {
      setDeleteId(item.id);
      setShowDelete(true);
    } else if (selectedOption === "approve") {
      handleApproveRejectLeave("accept", item.id);
    } else if (selectedOption === "reject") {
      // handleApproveRejectLeave("reject", item.id);
      setShowRejectModal(true);
    }
  };
  const handleReject = async () => {
    setLoading(true);
    await handleApproveRejectLeave("reject", item.id, rejectionReason);
    setShowRejectModal(false);
    setRejectionReason("");
    setLoading(false);
  };

  if (
    new Date(item.start_date).getFullYear() >= new Date().getFullYear() - 1 &&
    (user?.is_admin || user?.is_project_manager)
  ) {
    actionOptions.push(
      { value: "approve", label: "Approve" },
      { value: "reject", label: "Reject" }
    );
  }

  return (
    <>
      <select
        value={""}
        onChange={(e) => handleChange(e.target.value)}
        style={{
          width: "100%",
          border: "0px",
          boxShadow: "none",
          backgroundColor: "#EFF6FA",
          borderRadius: "5px",
          padding: "5px",
        }}
        className="w-100 p-1 border fs-16 focus-none"
      >
        <option value="" disabled>
          Select Action
        </option>
        {actionOptions?.map((action, index) => (
          <option key={index} value={action.value}>
            {action.label}
          </option>
        ))}
      </select>
      <Modal show={showRejectModal} onHide={() => setShowRejectModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Reject Leave</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="rejectionReason">
            <Form.Label>Please provide a reason for rejection:</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={rejectionReason}
              onChange={(e) => setRejectionReason(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowRejectModal(false)}>
            Cancel
          </Button>
          <Button
            variant="danger"
            disabled={!rejectionReason.trim() || loading}
            onClick={handleReject}
          >
            Reject Leave
            {loading && <Spinner className="ms-2" size="sm" />}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default LeaveActions;
